module.exports = __webpack_public_path__ + "img/surgical-consent-form.986c5f0c.svg";